import { render, staticRenderFns } from "./ScheduleWishesForm.vue?vue&type=template&id=41bd8378&"
import script from "./scheduleWishesForm.js?vue&type=script&lang=js&"
export * from "./scheduleWishesForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports